import { render } from "./Dealer.vue?vue&type=template&id=8ac19f28&scoped=true"
import script from "./Dealer.vue?vue&type=script&lang=js"
export * from "./Dealer.vue?vue&type=script&lang=js"

import "./Dealer.vue?vue&type=style&index=0&id=8ac19f28&lang=scss"
import "./Dealer.vue?vue&type=style&index=1&id=8ac19f28&scoped=true&lang=scss"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac19f28"]])

export default __exports__